/**
 * 공통 번역 - 한국어
 * Common translations - Korean
 */

export default {
  language_switch: '언어 전환',
  loading: '로딩 중...',
  error: '오류',
  success: '성공',
  confirm: '확인',
  cancel: '취소',
  close: '닫기',
  save: '저장',
  edit: '수정',
  delete: '삭제',
  search: '검색',
  submit: '제출',
  reset: '초기화',
  back: '뒤로',
  next: '다음',
  previous: '이전',
  more: '더보기',
  less: '접기',
  all: '전체',
  viewDetails: '자세히 보기',
  learnMore: '더 알아보기',
  contactUs: '문의하기',
  readMore: '더 읽기',
  download: '다운로드',
  comingSoon: '곧 제공 예정',
  clickToLocate: '클릭하면 지도에서 위치를 확인할 수 있습니다',
  mapOverview: '지도 개요',
  regionContactCenter: '지역 서비스 센터',
  serviceNodes: '서비스 센터',
  serviceRegionsLabel: '서비스 지역',
  coverageCapability: '커버리지',
  localSupport: '현지 지원',
  asiaPacificServiceNetwork: '아시아태평양 서비스 네트워크',
  clickCardToLocate: '오른쪽 지역 카드를 클릭하면 해당 서비스 센터를 빠르게 찾을 수 있습니다.',
  searchRegionPlaceholder: '지역 / 도시 / 주소 검색',
  zoomIn: '확대',
  zoomOut: '축소',
  resetView: '초기화',
  staticMapPreview: '정적 지도 보기',
  staticMapNote: '이 시각화는 서비스 범위를 보여주기 위한 것으로, 외부 지도 서비스에 의존하지 않습니다.',
  step: '단계',
  standardizedDeliveryPath: '표준화된 제공 경로',
  serviceProcessIntro: '초기 요구 정리부터 지속적인 최적화까지 전체 서비스 프로세스를 단계별로 추진하여 각 제공 단계의 핵심을 더 직관적으로 이해할 수 있도록 지원합니다.',
  phase: '단계',
  openChat: '채팅 열기',
  closeChat: '채팅 닫기',
  customerService: '고객 지원',
  send: '보내기',
  invalidType: '유형을 선택해 주세요',
  invalidRegion: '서비스 지역을 선택해 주세요',
  invalidCompanyName: '회사명을 입력해 주세요',
  invalidContactName: '담당자 이름을 입력해 주세요',
  invalidPosition: '직책을 입력해 주세요',
  invalidEmail: '이메일 주소를 입력해 주세요',
  invalidEmailFormat: '유효한 이메일 주소를 입력해 주세요',
  invalidPhone: '전화번호를 입력해 주세요',
  invalidPhoneFormat: '유효한 전화번호를 입력해 주세요',
  invalidIndustry: '업종을 선택해 주세요',
  invalidCompanySize: '회사 규모를 선택해 주세요',
  invalidServices: '관심 있는 서비스를 최소 1개 선택해 주세요',
  invalidMessage: '프로젝트 요구사항을 입력해 주세요',
  requestFailed: '요청에 실패했습니다',
  badRequest: '요청 파라미터가 올바르지 않습니다',
  unauthorized: '인증이 만료되었습니다. 다시 로그인해 주세요',
  forbidden: '이 리소스에 접근할 권한이 없습니다',
  notFound: '요청한 리소스를 찾을 수 없습니다',
  serverError: '서버 내부 오류',
  badGateway: '게이트웨이 오류',
  serviceUnavailable: '서비스를 일시적으로 사용할 수 없습니다',
  requestFailedWithStatus: '요청 실패, 상태 코드: {status}',
  requestTimeout: '요청 시간이 초과되었습니다. 잠시 후 다시 시도해 주세요',
  networkError: '네트워크 연결에 실패했습니다. 네트워크 상태를 확인해 주세요',
  submitFailedRetry: '제출에 실패했습니다. 잠시 후 다시 시도해 주세요',
  submitFailedCheck: '입력한 정보가 올바른지 확인해 주세요',
  submitFailedServer: '현재 서버에서 요청을 처리할 수 없습니다. 잠시 후 다시 시도해 주세요',
  submitFailedNetwork: '네트워크 연결에 실패했습니다. 네트워크를 확인한 후 다시 시도해 주세요',
  ticketList: {
    newTicket: '신규 접수 티켓',
    unassigned: '미배정',
    progressLabel: '진행률: {progress}%',
    status: {
      pending: '대기 중',
      inProgress: '처리 중',
      completed: '완료'
    },
    samples: {
      networkIssue: '네트워크 연결 장애',
      softwareInstall: '소프트웨어 설치 문제',
      systemOptimization: '시스템 성능 최적화',
      supportA: '기술 지원 A',
      supportB: '기술 지원 B'
    }
  },
  share: '공유',
  copy: '복사',
  copied: '복사됨',
  required: '필수',
  optional: '선택',
  placeholder: '입력해 주세요...'
}
